import { Button } from 'components/button/button-component';
import Link from 'next/link';

import { Typography } from '../../components/typography/typography-component';

const ReactSquadHero = () => {
  return (
    <div className="flex flex-col justify-center px-4 py-16 text-white sm:px-0">
      <Typography
        variant="h1"
        className="text-center font-inter text-4xl font-black leading-none sm:text-6xl sm:leading-snug"
      >
        The Boutique React Agency
        <br />
        <span className="bg-gradient-to-r from-[#FF8F00] to-[#FFC400] bg-clip-text text-fill-transparent">
          for SaaS Startups
        </span>
      </Typography>

      <div className="mt-16 flex flex-col items-center justify-center gap-8 sm:flex-row">
        <Link
          href="https://calendly.com/nikolas-earlynode/reactsquad-io-chat-via-boteatbrain?month=2023-07"
          target={'_blank'}
        >
          <Button
            className="mx-2 rounded-full px-12 text-black hover:bg-white"
            size="lg"
            variant="filled"
            color="white"
          >
            {"Let's Talk"}
          </Button>
        </Link>
        <a href="#how-it-works">
          <Button
            className="mx-2 rounded-full border-white px-12 font-default text-white hover:border-white hover:bg-white hover:bg-opacity-100 hover:text-black"
            size="lg"
            variant="outlined"
            color="white"
          >
            How it Works
          </Button>
        </a>
      </div>
    </div>
  );
};

export default ReactSquadHero;
